import { EllipsisContentColumn } from 'components/TableColumn/EllipsisContentColumn';
import { useMemo } from 'react';
import { URL_REGEX } from 'utils/ValidateUtils';

export const SiteAnnouncementContent: React.FC<{
  content: string;
  macroToHyperlink?: boolean;
}> = ({ content, macroToHyperlink = false }) => {
  const macroRegex = useMemo(
    () => new RegExp(`{${URL_REGEX.source}}`, 'g'),
    []
  );

  const replacedContent = useMemo(() => {
    if (!macroToHyperlink) {
      return content.replace(macroRegex, '$1');
    }
    // 將 content 以 macroRegex 分割，並將符合的部分轉成 <a>
    const parts: React.ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null = macroRegex.exec(content);
    while (match) {
      // match.index 是 macroRegex 匹配到部分的開始位置
      // 將前一段原文放入結果
      if (match.index > lastIndex) {
        parts.push(content.slice(lastIndex, match.index));
      }
      // 取出網址
      const url = match[1];
      parts.push(
        <a
          href={url}
          target='_blank'
          rel='noopener noreferrer'
          key={url + match.index}
        >
          {url}
        </a>
      );

      // 每次 regex test 完，regex.lastIndex 就會變成下次要開始搜尋的位置
      lastIndex = macroRegex.lastIndex;
      match = macroRegex.exec(content);
    }
    // 補上最後一段原文
    if (lastIndex < content.length) {
      parts.push(content.slice(lastIndex));
    }
    return parts;
  }, [content, macroToHyperlink, macroRegex]);

  return <div>{replacedContent}</div>;
};

export const renderSiteAnnouncementContent = (
  content: string,
  macroToHyperlink: boolean = false,
  lineClamp?: number
): React.ReactNode => {
  if (lineClamp !== undefined) {
    return (
      <EllipsisContentColumn
        content={
          <SiteAnnouncementContent
            content={content}
            macroToHyperlink={macroToHyperlink}
          />
        }
        lineClamp={lineClamp}
      />
    );
  }
  return (
    <SiteAnnouncementContent
      content={content}
      macroToHyperlink={macroToHyperlink}
    />
  );
};
